import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UserIcon from '../../images/common/user.svg';
import {
  Table,
  Thead,
  Tbody,
  Th,
  TrBody,
  Td,
  IconWrapper,
  SortColumn,
  CheckboxTh,
  CheckboxTd,
} from '../Group/styles/UserTableStyles';
import { TableContainer, TrHead } from './styles/MailSubscriptionListStyles';
import { convertRole } from '../../lib/tools';
import { ROLE } from '../../lib/constants';

/**
 * メール受信者一覧のコンポーネント
 * @param {Object} selectedOption - 選択されたオプション
 * @param {Object} deviceAuthSettings - デバイス認証設定
 * @param {Function} setDeviceAuthSettings - デバイス認証設定を更新する関数
 * @returns
 */
const MailRecipientList = ({
  selectedOption,
  deviceAuthSettings,
  onSubscriptionsChange,
}) => {
  const mailRecipient = useSelector(state => state.deviceAuth.operators);
  const [selectAll, setSelectAll] = useState(false);

  let sortedMailRecipient;
  switch (selectedOption) {
    case '1':
      sortedMailRecipient = [...mailRecipient].sort(
        (a, b) =>
          (b.role === ROLE.COMPANY_ADMIN) - (a.role === ROLE.COMPANY_ADMIN),
      );
      break;
    case '2':
      sortedMailRecipient = mailRecipient.filter(
        recipient => recipient.role === ROLE.COMPANY_ADMIN,
      );
      break;
    case '3':
      sortedMailRecipient = mailRecipient.filter(
        recipient => recipient.role === ROLE.ADMIN,
      );
      break;
    default:
      sortedMailRecipient = [...mailRecipient];
      break;
  }

  const operatorIds = deviceAuthSettings?.subscriptions?.operatorIds || [];

  // TODO: checkbox周りのロジックをカスタムフックとして切り出し

  const handleSelectItem = operatorId => {
    let newOperatorIds;
    if (operatorIds.includes(operatorId)) {
      newOperatorIds = operatorIds.filter(id => id !== operatorId);
      setSelectAll(false);
    } else {
      newOperatorIds = [...operatorIds, operatorId];
    }
    onSubscriptionsChange(newOperatorIds);

    // 全てのアイテムが選択されているかチェックして、チェックボックスの状態を更新
    const allSelected = mailRecipient.every(user =>
      newOperatorIds.includes(user.operatorId),
    );
    setSelectAll(allSelected);
  };

  const handleSelectAll = () => {
    const newSelectedItems = {};
    if (!selectAll) {
      sortedMailRecipient.forEach(user => {
        newSelectedItems[user.operatorId] = true;
      });
    }
    setSelectAll(!selectAll);
    onSubscriptionsChange(Object.keys(newSelectedItems).map(Number));
  };

  return (
    <TableContainer>
      <Table>
        <Thead>
          <TrHead>
            <CheckboxTh>
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              />
            </CheckboxTh>
            <Th style={{ flex: 6 }}>
              <SortColumn>
                <FormattedMessage id="accessControlPage.subscriptionsTable.title.name" />
              </SortColumn>
            </Th>
            <Th style={{ flex: 4 }}>
              <SortColumn>
                <FormattedMessage id="accessControlPage.subscriptionsTable.title.role" />
              </SortColumn>
            </Th>
          </TrHead>
        </Thead>
        <Tbody>
          {sortedMailRecipient.map(user => (
            <TrBody key={user.operatorId}>
              <CheckboxTd>
                <input
                  type="checkbox"
                  checked={operatorIds.includes(user.operatorId)}
                  onChange={() => handleSelectItem(user.operatorId)}
                />
              </CheckboxTd>
              <Td style={{ flex: 6 }}>
                <IconWrapper src={UserIcon} alt="icon" />
                {user.name}
              </Td>
              <Td style={{ flex: 4 }}>{convertRole(user.role)}</Td>
            </TrBody>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

MailRecipientList.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  deviceAuthSettings: PropTypes.shape({
    isEnabled: PropTypes.bool,
    ipAddresses: PropTypes.arrayOf(PropTypes.string),
    subscriptions: PropTypes.object.isRequired,
  }),
  onSubscriptionsChange: PropTypes.func.isRequired,
};

MailRecipientList.defaultProps = {
  deviceAuthSettings: {
    isEnabled: null,
    ipAddresses: [],
    subscriptions: {},
  },
};

export default MailRecipientList;
